import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import InstallAppSection from '../components/InstallAppSection';

export default function InstallPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background" data-testid="install-page">
      <Header />
      <main className="flex-1">
        <section className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-20">
          <InstallAppSection />

          <div className="mt-10 grid sm:grid-cols-3 gap-4 text-sm">
            {[
              { title: 'Works offline', body: 'Browse products and your order history even with spotty signal.' },
              { title: 'Home-screen icon', body: 'Tap once and you\u2019re in — no login screen every time.' },
              { title: 'Order updates', body: 'Get pinged the moment your order ships or a vendor replies.' },
            ].map((f) => (
              <div key={f.title} className="bg-muted/30 rounded-xl p-4 border border-border">
                <h3 className="font-medium mb-1">{f.title}</h3>
                <p className="text-xs text-muted-foreground">{f.body}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 text-center">
            <p className="text-sm text-muted-foreground">
              Trouble installing?{' '}
              <a
                href="mailto:admin@christkingdomglobalmarketplace.com?subject=App+install+help"
                className="text-primary underline"
                data-testid="install-help-link"
              >
                Email us
              </a>{' '}
              — we&rsquo;ll walk you through it.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
